import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import StrategicRoi from "@/pages/StrategicRoi";
import Assessment from "@/pages/Assessment";
import AgentTeam from "@/pages/AgentTeam";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/strategicroi" element={<StrategicRoi />} />
        <Route path="/assessment" element={<Assessment />} />
        <Route path="/agent-team" element={<AgentTeam />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
